import { Box } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import Button from "src/components/Button"
import CustomCard from "src/components/CustomCard"
import Text from "src/components/Text"
import { useIsMobile } from "src/hooks/useIsMobile"
import { formatNumber } from "src/utils/parseStringToBigNumber"
import { useVaultsApr } from "../../hooks/useVaultsApr"

const RecommendSection = () => {
  const { t } = useTranslation()
  const vaultsApr = useVaultsApr()
  const isMobile = useIsMobile()

  const earnMaxApr =
    vaultsApr.length === 0
      ? 0
      : Math.max(...vaultsApr.map((x) => parseFloat(x.apr)))

  return (
    <CustomCard p={2} mt={3} variant="black50">
      <Box
        display={isMobile ? "block" : "flex"}
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Box display="flex" flexDirection="column" maxWidth="370px">
          <Box alignItems="center" justifyContent="flex-start">
            <Text size="small">{t("Boost Your Earnings")}</Text>
          </Box>
          <Text mr="4px" bold mt={0.5} mb={{ xs: 2, sm: 0 }}>
            {t("Deposit your xFER into our vault to earn up to ")}
            {formatNumber(earnMaxApr, 2, 2)}% APR!
          </Text>
        </Box>
        <Button size="small" width={isMobile ? "100%" : "auto"}>
          <Link to="/stake/vault">{t("See Vault")}</Link>
        </Button>
      </Box>
    </CustomCard>
  )
}

export default RecommendSection
